import { useContext, useEffect, useState } from 'react'
import ReactDatePicker from 'react-datepicker';
import ImportDevices from './Devices/importdevices';
import Exportdevices from './Devices/exportdevices';
import ImportUsers from './Users/importusers';
import Exportusers from './Users/exportusers';
import Importtickets from './Tickets/importtickets';
import Exporttickets from './Tickets/exporttickets';
import { UserContext } from '../../App';
import ExportMasterInventory from './MasterInventory/ExportMasterInventory';
import ImportInventory from './MasterInventory/importinventory';
import ImportGoogleDevices from './GoogleIntegration/ImportGoogleDevices';
import CustomCsvImports from './CustomCsvImports';
import ImportBuildingRoom from './BuildingRoom/ImportBuildingRoom';
import ExportbuildingroomComp from './BuildingRoom/exportbuildingroom';
import PageHead from '../../Components/PageHead';
import ImportHelpdeskItems from './HelpdeskItems/ImportHelpdeskItems';
import ExportSchoolProfile from './SchoolProfile/exportSchoolProfile';
import ImportSchoolProfile from './SchoolProfile/ImportSchoolProfile';
import AdminImportDevices from './Devices/AdminImportDevices';
import ImportIQDevices from './IncidentIQ/ImportIQDevices';
import ImportCustomPriceParts from './CustomPriceParts/ImportCustomPriceParts';
import ExportCustomPriceParts from './CustomPriceParts/ExportCustomPriceParts';
import { useSelector } from 'react-redux';
import { ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';
import UpdateSerialNumber from './DeviceModels/UpdateSerialNumber';
import { HideLoder, ShowLoder, userTimeZone } from '../../JS/Common';
import ImportDeviceModels from './DeviceModels/ImportDeviceModels';
import ExportDeviceModels from './DeviceModels/ExportDeviceModels';

export function ImportExport() {
    const { show_custom_imp_exp } = useConfig();
    const { UserData } = useContext(UserContext);
    const { role, schoolImpExpFlag, adminImpExpFlag, copyrole } = UserData;
    const StateData = useSelector((state) => state.authData);
    const [ShowLoader, setShowLoader] = useState(false);
    const [Alerts, setAlerts] = useState("");
    const today = new Date(
        new Date().toLocaleString("en-US", { timeZone: userTimeZone })
    );

    const oneMonthAgo = new Date(today);

    oneMonthAgo.setDate(1);
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    const day = today.getDate();

    const lastDayOfPreviousMonth = new Date(
        oneMonthAgo.getFullYear(),
        oneMonthAgo.getMonth() + 1,
        0
    ).getDate();

    oneMonthAgo.setDate(
        Math.min(day, lastDayOfPreviousMonth)
    );
    const [FilterData, setFilterData] = useState({
        StartDate: oneMonthAgo,
        EndDate: today,
    });
    const effectiveRole = copyrole || role || null;

    const syncHubSpot = async () => {
        setShowLoader(true)
        var raw = JSON.stringify({
            "sid": 0,
            "uid": StateData.csvUserID || null,
            "flag": 3
        });

        await ApiPostCall("/hubspot/accounts/sync", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setShowLoader(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={responseRs.message} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        })
    }

    function handleStartDateChange(date) {
        setFilterData((prevdata) => ({ ...prevdata, StartDate: date }));
    };

    function handleEndDateChange(date) {
        setFilterData((prevdata) => ({ ...prevdata, EndDate: date }));
    };

    return (
        <>
            {Alerts}
            {ShowLoader ? <ShowLoder /> : <HideLoder />}
            <div className='row pe-0 align-items-center'>
                <div className='col-md-8'>
                    <h1 className="PageHeading">Import/Export</h1>
                </div>
                <div className="col-md-4 text-end row px-0">
                    <div className="col-md-6 d-flex  align-items-center py-2 px-0">
                        <label className="px-3"></label>
                        <ReactDatePicker
                            className="form-control me-4 text-center"
                            selected={FilterData.StartDate}
                            onChange={(e) => { handleStartDateChange(e); }}
                            dateFormat="MM/dd/yyyy"
                            maxDate={today}
                        />
                    </div>
                    <div className="col-md-6 d-flex  align-items-center py-2 px-0">
                        <label className="px-3">To</label>
                        <ReactDatePicker
                            className="form-control me-4 text-center"
                            selected={FilterData.EndDate}
                            onChange={(e) => { handleEndDateChange(e); }}
                            dateFormat="MM/dd/yyyy"
                            maxDate={today}
                        />
                    </div>
                </div>
            </div>
            {schoolImpExpFlag == 2 ?
                <div className='GridBox mt-3 p-3'>
                    <div className='row'>
                        <div className='col-md-6 py-2'>
                            <div className="greyBox" style={{ height: "100%" }}>
                                <ImportGoogleDevices />
                            </div>
                        </div>

                        <div className='col-md-6 py-2'>
                            <div className="greyBox" style={{ height: "100%" }}>
                                <ImportIQDevices />
                            </div>
                        </div>
                        <div className='col-12 py-2'>
                            {show_custom_imp_exp && (
                                <div className="greyBox" style={{ height: "100%" }}>
                                    <CustomCsvImports />
                                </div>
                            )}
                        </div>
                        <div className='col-md-6 py-2'>
                            <div className="greyBox" style={{ height: "100%" }}>
                                <ImportDevices />
                            </div>
                        </div>
                        <div className='col-md-6 py-2'>
                            <div className="greyBox" style={{ height: "100%" }}>
                                <Exportdevices FilterData={FilterData} setAlerts={setAlerts} />
                            </div>
                        </div>
                        <div className='col-md-12 py-2'>
                            <div className="greyBox">
                                <UpdateSerialNumber FilterData={FilterData} />
                            </div>
                        </div>
                        <div className='col-md-6 py-2'>
                            <div className="greyBox" style={{ height: "100%" }}>
                                <ImportUsers />
                            </div>
                        </div>
                        <div className='col-md-6 py-2'>
                            <div className="greyBox" style={{ height: "100%" }}>
                                <Exportusers FilterData={FilterData} setAlerts={setAlerts} />
                            </div>
                        </div>
                        <div className='col-md-6 py-2'>
                            <div className="greyBox" style={{ height: "100%" }}>
                                <Importtickets />
                            </div>
                        </div>
                        <div className='col-md-6 py-2'>
                            <div className="greyBox" style={{ height: "100%" }}>
                                <Exporttickets FilterData={FilterData} setAlerts={setAlerts} />
                            </div>
                        </div>
                        <div className='col-md-6 py-2'>
                            <div className="greyBox" style={{ height: "100%" }}>
                                <ImportBuildingRoom />
                            </div>
                        </div>
                        <div className='col-md-6 py-2'>
                            <div className="greyBox" style={{ height: "100%" }}>
                                <ExportbuildingroomComp FilterData={FilterData} />
                            </div>
                        </div>
                        {UserData.helpdeskUpdatedFlag != null &&
                            <div className='col-md-6 py-2'>
                                <div className="greyBox" style={{ height: "100%" }}>
                                    <ImportHelpdeskItems />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                :
                <>
                    {UserData.oneTimeSyncHubSpot && (
                        <div className="offset-md-9 col-md-3 pe-0 text-end my-1">
                            <button className='SaveBtn ' onClick={syncHubSpot}>
                                Sync HubSpot
                            </button>
                        </div>
                    )}
                    <div className='GridBox mt-2 p-3'>
                        {adminImpExpFlag == 1 &&
                            <>
                                <div className='row'>
                                    <div className='col-md-6 py-2'>
                                        <div className="greyBox" style={{ height: "100%" }}>
                                            <ImportSchoolProfile />
                                        </div>
                                    </div>
                                    <div className='col-md-6 py-2'>
                                        <div className="greyBox" style={{ height: "100%" }}>
                                            <ExportSchoolProfile FilterData={FilterData} />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6 py-2'>
                                        <div className="greyBox" style={{ height: "100%" }}>
                                            <ImportInventory />
                                        </div>
                                    </div>
                                    <div className='col-md-6 py-2'>
                                        <div className="greyBox" style={{ height: "100%" }}>
                                            <ExportMasterInventory FilterData={FilterData} />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6 py-2'>
                                        <div className="greyBox" style={{ height: "100%" }}>
                                            <ImportCustomPriceParts />
                                        </div>
                                    </div>
                                    <div className='col-md-6 py-2'>
                                        <div className="greyBox" style={{ height: "100%" }}>
                                            <ExportCustomPriceParts FilterData={FilterData} />
                                        </div>
                                    </div>
                                </div>
                                {hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_TECH) && (
                                    <div className='row'>
                                        <div className='col-md-6 py-2'>
                                            <div className="greyBox" style={{ height: "100%" }}>
                                                <ImportDeviceModels />
                                            </div>
                                        </div>
                                        <div className='col-md-6 py-2'>
                                            <div className="greyBox" style={{ height: "100%" }}>
                                                <ExportDeviceModels FilterData={FilterData} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        }
                        <div className='row'>
                            <div className='col-md-6 py-2'>
                                <div className="greyBox" style={{ height: "100%" }}>
                                    <AdminImportDevices />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}
